import React from "react";
import { Snackbar, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons/";

const ErrorIndicator = props => (
  <Snackbar
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left"
    }}
    open={props.open}
    message={props.error}
    autoHideDuration={3000}
    onClose={props.onClick}
    action={[
      <IconButton key="close" color="inherit" onClick={props.onClick}>
        <Close />
      </IconButton>
    ]}
  />
);

export default ErrorIndicator;
